import { DialogContent, Modal } from "@mui/material"
import { setFocus } from "@noriginmedia/norigin-spatial-navigation"
import React, { useEffect } from "react"

import { useModalDismiss } from "../../hooks/use-modal-dismiss"
import { comb } from "../../utilities/common"
import { LocaleSelectScreen } from "../LocaleSelect/LocaleSelectScreen"

export const LanguageModal = ({
  open,
  returnFocus,
}: {
  open: comb<boolean>
  returnFocus: string
}) => {
  if (!open.val) return null
  return <Screen open={open} returnFocus={returnFocus} />
}

const Screen = ({
  open,
  returnFocus,
}: {
  open: comb<boolean>
  returnFocus: string
}) => {
  useModalDismiss(() => {
    setFocus(returnFocus)
    open.set(false)
  })
  useEffect(() => {
    setFocus("langaugeSelect0")
  }, [setFocus])
  return (
    // can't use the "loading_in" class because on Tizen (newer versions) the opacity overlay seems to kill the video
    <Modal
      open={true}
      sx={{
        position: "fixed",
        zIndex: 1301,
        top: 0,
        left: 0,
        visibility: open ? "visible" : "hidden",
        height: "100vh",
        width: "100vw",
        backgroundColor: "black",
        "& > *": { transition: "none !important" },
      }}
    >
      <DialogContent>
        <LocaleSelectScreen open={open} />
      </DialogContent>
    </Modal>
  )
}
